import { PurchaseAndSeven } from '@/api/purchaseAndSaleAPI'
import { searchByCustomerName } from '@/api/domain/customers'
import selectOption from '@/store/dict/selectOptionDict'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export default function (data) {
  /* 客户列表 */
  const searchByCustomerNameFunc = async (query) => {
    if (query.length < 1) return
    searchByCustomerName({
      customerType: 2,

      customerState: 1,
      customerName: query,
    }).then((res) => {
      const _list = res?.code === 1 ? res?.data : []
      this.configData.formData.list[1].elConfig.options.list = _list
    })
  }
  function dealWithSearch(params) {
    if (data.dealWithData) data.dealWithData(params)
    if (params.startTime && params.startTime.length) {
      params.createTimeStart = params.startTime[0]
      params.createTimeEnd = params.startTime[1]
    }
    return params
  }
  const configData = {
    formData: {
      formProps: {
        ref: 'searchForm',
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '企业租赁订单ID',
            prop: 'entRentOrderId',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入企业租赁订单ID',
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            clearable: true,
            placeholder: '请输入',
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            'remote-method': searchByCustomerNameFunc,
            options: {
              // 下拉数据
              label: 'customerName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const customerItem = this.configData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
                this.customerConditionList = customerItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '子订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入子订单ID',
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '子订单创建时间',
            prop: 'startTime',
          },
        },
      ],
      dealWithSearch, // 查询
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '子订单ID',
            width: '120',
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '子订单创建时间',
            width: '160',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            label: '每期租金(元)',
            width: '110',
            formatter: (row) => {
              const { orderConfig } = row
              const { piecewiseCalculation } = orderConfig || {}
              const { isOpen = 0 } = piecewiseCalculation || {}
              // 阶梯方案 展示'--'
              if (orderConfig && Number(isOpen) === 1) {
                return '--'
              }
              return this.numberWithCommas(row.rentAmount)
            },
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '押金',
            align: 'right',
            formatter: (row) => {
              return `${row.deposit === null ? '0.00' : row.deposit}/${
                row.receivedDeposit
              }`
            },
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
            width: '120',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
            width: '120',
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '子订单状态',
            formatter: (row) => selectOption.leaseOrderState[row.state],
            width: '120',
          },
        },
        {
          name: 'entRentOrderId',
          columnProps: {
            label: '企业租赁订单ID',
            width: '120',
          },
          render: ({ row }) => {
            const configObj = {
              label: 'span',
              value: row.entRentOrderId || '--',
            }
            return renderContent.call(this, configObj)
          },
        },
      ],
      apiFn: PurchaseAndSeven,
    },
  }
  return {
    configData,
  }
}
function renderContent(
  configObj = { label: 'span', value: '', className: '' },
) {
  return this.$createElement(
    configObj.label,
    {
      class: configObj.className,
      on: {
        click: configObj.fn || '',
      },
    },
    configObj.value,
  )
}
